module.exports = __webpack_public_path__ + "static/gallery-img-22-8d506f639427340c9e0f426ee8c580f5.jpg";